import { styled } from '@linaria/react';
import { bodyFont, fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  padding-bottom: ${space['space-400']};
`;

export const ApplyAllRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
  padding: ${space['space-200']} 0;
`;

export const ApplyAllLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
`;

export const Section = styled.section`
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xl']};
  padding: ${space['space-400']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const PlainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const SectionHeading = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.tight};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const TimesBlock = styled.div`
  border-top: 1px solid ${semantic.border.default};
  padding-top: ${space['space-400']};
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
`;

export const QuantityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const QuantityLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const QuantityPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;
